import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class ComisionesService {
  public url: string;
  public urlPDF: string;
  urlAliado: string;
  public data: any;

  constructor(
    private http: HttpClient
  ) {
    this.urlAliado = environment.apiLocalUrl + 'intermediarioFinanciero/services/';
    this.url = environment.apiLocalUrl + 'bancoldex/servicios/';
    this.urlPDF = environment.apiLocalUrl + 'bancoldex/servicios/cuentaCobro/';
  }

  consultarCuentasAliado(body: any){
    return this.http.post(`${this.urlAliado}cuentasCobro`, body);
  }

  generarPDF(idCuenta: any){
    return this.http.get(`${this.urlPDF}generarPdf/${idCuenta}`);
  }

  exportarDocumento(
    body: any
  ): Observable<any[]> {
    const headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post<any[]>(`${this.urlAliado}exportarCuentasCobro`, body, {
      headers: headers,
    });
  }

  obtenerJustificacion(idCuenta: any){
    return this.http.get(`${this.url}cuentacobro/obtenerMotivo/${idCuenta}`);
  }

  public getData(): any{
    return this.data;
  }

  public setData(data: any){
    this.data = data;
  }

}
